/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PostProductRequest } from '../../models/post-product-request';
import { PostProductResponse } from '../../models/post-product-response';

export interface UpdateProducts$Params {
  
    /**
     * XML payload containing product data to submit for mapping
     */
    body: PostProductRequest
}

export function updateProducts(http: HttpClient, rootUrl: string, params: UpdateProducts$Params, context?: HttpContext): Observable<StrictHttpResponse<PostProductResponse>> {
  const rb = new RequestBuilder(rootUrl, updateProducts.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/xml');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PostProductResponse>;
    })
  );
}

updateProducts.PATH = '/products';
